__turbopack_context__.v({
  "GC": "styles-module-scss-module__-ifz3a__GC",
  "SC": "styles-module-scss-module__-ifz3a__SC",
  "button-loading-spinner": "styles-module-scss-module__-ifz3a__button-loading-spinner",
  "default": "styles-module-scss-module__-ifz3a__default",
  "disabled": "styles-module-scss-module__-ifz3a__disabled",
  "loading": "styles-module-scss-module__-ifz3a__loading",
  "root": "styles-module-scss-module__-ifz3a__root",
});
